export const getFileIconClass = (fileName?: string): string => {
  if (!fileName) {
    return "icon-file";
  }

  const extension = fileName.split(".").pop()?.toLowerCase();

  switch (extension) {
    case "jpg":
    case "jpeg":
      return "icon-jpg";
    case "png":
      return "icon-png";
    case "txt":
      return "icon-txt";
    case "xls":
    case "xlsx":
      return "icon-xls-file";
    case "pdf":
      return "icon-pdf";
    case "doc":
    case "docx":
      return "icon-doc";
    default:
      return "icon-file";
  }
};
